<template>
  <v-container>Refreshing ...</v-container>
</template>

<script>
export default {
    created(){
        setTimeout(()=>{
            this.$router.push({name:'FlightSearch'});
        },1000);
    },
}
</script>

<style>

</style>